(() => {
  const showMoreButton = $(".home-product-slider__show-more");
  const productSlider = $(".home-product-slider__slide");

  if (productSlider.length > 4) {
    showMoreButton.on("click", () => {
      productSlider.addClass("home-product-slider__slide--show-all");
      showMoreButton.hide();
    });
  } else {
    showMoreButton.hide();
  }
})();
